<template>
  <div class="errors-page">
    <div class="errors-page__overlay"></div>
    <div class="errors-page__info">
      <div class="errors-page__text">
        При загрузке данных системы произошла ошибка.
        <br />Перезагрузите, пожалуйста, страницу
      </div>
      <div class="errors-page__actions">
        <i-button type="primary" size="large" @click="reload">
          Перезагрузить
        </i-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    reload () {
      location.reload()
    }
  }
}
</script>

<style lang="less">
.errors-page {
  width: 100vw;
  height: 100vh;
  background-color: #232b38;
  z-index: 1000;
  background-image: url("../../assets/bg_dark.jpg");
  background-size: cover;
  background-position: 50% 50%;
  position: relative;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(#232b38, 0.6);
  }

  &__info {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__text {
    color: #fff;
    text-align: center;
    font-size: 16px;
  }

  &__actions {
    margin-top: 16px;
    text-align: center;
  }
}
</style>
